function LogoutIconDark() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="36"
      viewBox="0 0 35 36"
      fill="none"
    >
      <path
        d="M26.25 11.9215L32.0833 17.7549M32.0833 17.7549L26.25 23.5882M32.0833 17.7549H13.125M21.875 6.38577C20.016 5.26903 17.8577 4.62988 15.5556 4.62988C8.57529 4.62988 2.91667 10.5061 2.91667 17.7549C2.91667 25.0036 8.57529 30.8799 15.5556 30.8799C17.8577 30.8799 20.016 30.2407 21.875 29.124"
        stroke="#F6AE2D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function LogoutIconLight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="36"
      viewBox="0 0 35 36"
      fill="none"
    >
      <path
        d="M26.25 12.1169L32.0833 17.9502M32.0833 17.9502L26.25 23.7835M32.0833 17.9502H13.125M21.875 6.58109C20.016 5.46435 17.8577 4.8252 15.5556 4.8252C8.57529 4.8252 2.91667 10.7015 2.91667 17.9502C2.91667 25.1989 8.57529 31.0752 15.5556 31.0752C17.8577 31.0752 20.016 30.436 21.875 29.3193"
        stroke="#BCCCDC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.25 12.1169L32.0833 17.9502M32.0833 17.9502L26.25 23.7835M32.0833 17.9502H13.125M21.875 6.58109C20.016 5.46435 17.8577 4.8252 15.5556 4.8252C8.57529 4.8252 2.91667 10.7015 2.91667 17.9502C2.91667 25.1989 8.57529 31.0752 15.5556 31.0752C17.8577 31.0752 20.016 30.436 21.875 29.3193"
        stroke="#1C202A"
        strokeOpacity="0.3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function LogoutIcon({
  mode = 'dark',
}: {
  mode?: 'light' | 'dark';
}) {
  return <>{mode === 'dark' ? <LogoutIconDark /> : <LogoutIconLight />}</>;
}
